import React, {useState} from "react";
import './blacklist.scss';
import backArrow from "../../../assets/icons/back_arrow.svg";
import {generatePath, withRouter} from "react-router-dom";
import TableComponent from "../../../shared/components/TableComponent";
import avatarPlaceholder from "../../../assets/placeholder/avatar_placeholder.png";
import {Dropdown, Menu} from "antd";
import menuIcon from "../../../assets/icons/menu-icon.svg";
import * as appRoutes from "../../../routes/routeConstants/appRoutes";
import SearchBar from "../../../shared/components/SearchBar";
import filterIcon from "../../../assets/icons/filter-icon.svg";
import DeleteAlert from "../../../shared/components/DeleteAlert";

const Blacklist = (props:any) => {

    const [currentStudent,setCurrentStudent] = useState<any>();
    const [showBlacklistAlert, setShowBlacklistAlert] = useState<boolean>(false);
    const [blacklistReason, setBlacklistReason] = useState<string>('');

    const menu = (
        <Menu className='courses__card__menu'>
            <Menu.Item key="edit" onClick={()=>{setShowBlacklistAlert(true)}}>
                Remove from blacklist
            </Menu.Item>
        </Menu>
    );

    const handleSearch = (value:string) => {console.log(value)}

    const columns = [
        {
            title: 'Student ID',
            dataIndex: 'studentId',
            key: 'studentId',
            sorter: (a:any, b:any) => a.studentId - b.studentId
        },
        {
            title: 'Name',
            dataIndex: 'fullName',
            key: 'fullName',
            render:(name:string)=> <><img src={avatarPlaceholder} alt='' className='table-image'/> {name}</>,
            sorter: (a:any, b:any) => a.fullName - b.fullName
        },
        {
            title: 'Student Email',
            dataIndex: 'studentEmail',
            key: 'studentEmail',
        },
        {
            title: 'Student Phone',
            dataIndex: 'studentPhone',
            key: 'studentPhone',
        },
        {
            title: 'Parent Email',
            dataIndex: 'parentEmail',
            key: 'parentEmail',
        },
        {
            title: 'Parent Phone',
            dataIndex: 'parentPhone',
            key: 'parentPhone',
        },
        {
            title: 'Blacklist Since',
            dataIndex: 'blacklistSince',
            key: 'blacklistSince',
        },
        {
            title: '',
            dataIndex: '',
            key: 'action',
            render: (text:string,record:any,index:number) =>
                <div onClick={(event)=>{
                    event.stopPropagation();
                    setCurrentStudent(record)
                }}>
                    <Dropdown overlay={menu}
                              trigger={['click']}
                              placement={'bottomRight'}
                              className='course__dropdown'
                              onVisibleChange={(visible) =>{console.log(visible)}}
                    >
                        <img src={menuIcon} alt=''/>
                    </Dropdown>
                </div>

        },
    ];

    const dataSource = [
        {
            key:1,
            id: 1,
            studentId: 'S0001',
            firstName: 'Student',
            lastName: '1',
            fullName: 'Student 1',
            studentEmail: 'student@email.com',
            studentPhone: '+91 99999 99999',
            parentEmail: 'parent@email.com',
            parentPhone: '+91 11111 11111',
            blacklistSince: 'Jan 01,2000'
        },
        {
            key:2,
            id: 2,
            studentId: 'S0002',
            firstName: 'Student',
            lastName: '2',
            fullName: 'Student 2',
            studentEmail: 'student@email.com',
            studentPhone: '+91 99999 99999',
            parentEmail: 'parent@email.com',
            parentPhone: '+91 11111 11111',
            blacklistSince: 'Jan 01,2000'
        },
        {
            key:3,
            id: 3,
            studentId: 'S0003',
            firstName: 'Student',
            lastName: '3',
            fullName: 'Student 3',
            studentEmail: 'student@email.com',
            studentPhone: '+91 99999 99999',
            parentEmail: 'parent@email.com',
            parentPhone: '+91 11111 11111',
            blacklistSince: 'Jan 01,2000'
        },
    ];

    return(
        <div className='page-view'>
            <div className='blacklist__back'>
                <img src={backArrow} alt='' onClick={()=>props.history.goBack()}/>
            </div>
            <div className='blacklist__header'>
                <div className='header-title'>Blacklisted students</div>
                <div className='header-options'>
                    <div className='header-options__search'>
                        <SearchBar handleSearch={handleSearch}/>
                    </div>
                    <div className='header-options__filter'>
                        <img src={filterIcon} alt=''/>
                    </div>
                </div>
            </div>
            <TableComponent dataSource={dataSource}
                            columns={columns}
                            handleRowClick={(e:any,record:any)=>{
                                props.history.push(generatePath(appRoutes.STUDENT_DETAILS,{studentId:record.id}))
                            }}
            />
            <DeleteAlert visible={showBlacklistAlert}
                         setVisible={setShowBlacklistAlert}
                         deleteContent={'Are you sure to remove the student from blacklist?'}
                         deleteWarning={'On removing, Student gets access to the application'}
                         logo={avatarPlaceholder}
                         contentTitle={currentStudent?.fullName}
                         contentSubject={currentStudent?.studentPhone}
                         blacklist={'remove'}
                         setBlacklistReason={setBlacklistReason}
            />
        </div>
    )
}

export default withRouter(Blacklist);
